import script from "./Page11.vue?vue&type=script&setup=true&lang=js"
export * from "./Page11.vue?vue&type=script&setup=true&lang=js"

import "./Page11.vue?vue&type=style&index=0&id=fd496a0a&lang=less"

const __exports__ = script;

export default __exports__